import React, { useState, useEffect } from "react";
import { api } from "../../api/axios";
import { toast } from "react-hot-toast";

export default function MarqueeSettings() {
  const [marqueeText, setMarqueeText] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get("/settings");
      if (response.data && response.data.marqueeText) {
        setMarqueeText(response.data.marqueeText);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load marquee settings");
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put("/settings/marquee", { marqueeText });
      toast.success("Marquee text updated successfully");
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message || "Failed to update marquee text"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">Marquee Settings</h5>
        </div>
        <div className="card-body">
          <p className="text-muted small">
            Update the scrolling text displayed at the top of the home page. You can use HTML tags (like <code>&lt;a href="..."&gt;</code>) if you need links.
          </p>
          <div className="form-group mb-3">
            <label className="form-label fw-bold">Marquee Content</label>
            <textarea
              className="form-control"
              rows={5}
              value={marqueeText}
              onChange={(e) => setMarqueeText(e.target.value)}
              placeholder="Enter marquee text..."
            ></textarea>
          </div>
          <button
            className="btn btn-primary px-4"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}
